import { IDBEntityCacheStore } from "./IDBEntityCacheStore";
import { Timeouts } from "@gap/utils/date-utils";
import { apiClientSilent } from "api/trpc/trpc-client";

interface Metrics {
   completedWorkItems: number
   openWorkItems: number
   acceptedProposals: number
}

export class IDBMetricsCache {
   static get = async (): Promise<Metrics> => {
      return await IDBMetricsCache.cache().fetch() || {
         completedWorkItems: 0,
         openWorkItems: 0,
         acceptedProposals: 0
      }
   }

   static invalidate = async () => {
      await IDBMetricsCache.cache().invalidate()
   }

   private static cache = () => {
      return new IDBEntityCacheStore<Metrics>({
         entityKey: `metrics`,
         fetcher: () => apiClientSilent.metrics.get.query(),
         cacheOptions: {
            ttlMs: Timeouts.minute * 10
         }
      })
   }
}
